import React, { useCallback, useEffect, useRef } from 'react';
import { DateUtils, TypeUtils } from '@vectord/utils';
import { Tappable, Tooltip } from '@vectord/components';
import classNames from 'classnames';

import styles from './CoursePauseSbatLectureRow.module.scss';

function CoursePauseSbatLectureRow({
  lecture,
  isSelectable,
  onSelect,
  isSelected,
}) {
  const lectureRef = useRef(null);
  const { academy_topic: academyTopic, date_of_topic: dateOfTopic } = lecture;
  const { academy_module: academyModule } = academyTopic || {};
  const date = `${DateUtils.toDateDayTime(dateOfTopic)}`;
  const isFutureDate = new Date(dateOfTopic) >= new Date().getTime();

  const handleOnSelect = useCallback(() => {
    if (isSelectable) {
      if (TypeUtils.isFunction(onSelect)) {
        onSelect(lecture);
      }
    }
  }, [isSelectable, lecture, onSelect]);

  useEffect(() => {
    if (isSelected) {
      lectureRef.current.scrollIntoView({
        behavior: 'instant',
        block: 'center',
      });
      if (isSelectable && TypeUtils.isFunction(onSelect)) {
        onSelect(lecture);
      }
    }
  }, [isSelectable, isSelected, lecture, onSelect]);

  return (
    <Tooltip
      title={
        'Resume is only possible for current or future date. Please select valid date and retry'
      }
      isDisabled={!isSelectable || isFutureDate}
    >
      <Tappable
        ref={lectureRef}
        className={classNames(styles.root, {
          [styles.selectedLecture]: isSelected,
        })}
        onClick={handleOnSelect}
        disabled={isSelectable && !isFutureDate}
      >
        <div className={styles.detail}>
          <Tooltip
            title={academyModule?.name}
            isDisabled={isSelectable && !isFutureDate}
          >
            {academyModule?.name}
          </Tooltip>
        </div>
        <div className={classNames(styles.detail, 'p-h-xxs')}>
          <Tooltip
            title={academyTopic.title}
            isDisabled={isSelectable && !isFutureDate}
          >
            {academyTopic.title}
          </Tooltip>
        </div>
        <div className={styles.detail}>
          <Tooltip
            title={date}
            isDisabled={isSelectable && !isFutureDate}
          >
            {date}
          </Tooltip>
        </div>
      </Tappable>
    </Tooltip>
  );
}

export default CoursePauseSbatLectureRow;
